import React from 'react';
export function TermsContent() {
  return <div className="space-y-4 text-sm md:text-base" data-id="element-230">
      <p data-id="element-231">
        <strong data-id="element-232">Last Updated: {new Date().toLocaleDateString()}</strong>
      </p>

      <h3 data-id="element-233">1. Agreement to Terms</h3>
      <p data-id="element-234">
        By accessing or using our website and purchasing our digital products,
        you agree to be bound by these Terms of Service and all terms
        incorporated by reference. If you do not agree to all of these terms, do
        not use our website or products.
      </p>

      <h3 data-id="element-235">2. Medical Disclaimer</h3>
      <p className="font-bold text-[#C4654A]" data-id="element-236">
        The content provided in the No-Fall Confidence plan is for educational
        and informational purposes only. It is not intended as a substitute for
        professional medical advice, diagnosis, or treatment.
      </p>
      <p data-id="element-237">
        Always seek the advice of your physician or other qualified health
        provider with any questions you may have regarding a medical condition.
        Never disregard professional medical advice or delay in seeking it
        because of something you have read in our materials.
      </p>
      <p data-id="element-238">
        If you think you may have a medical emergency, call your doctor or
        emergency services immediately. Reliance on any information provided by
        No-Fall Confidence is solely at your own risk.
      </p>

      <h3 data-id="element-239">3. Intellectual Property Rights</h3>
      <p data-id="element-240">
        Unless otherwise indicated, the Site and our digital products are our
        proprietary property and all source code, databases, functionality,
        software, website designs, audio, video, text, photographs, and graphics
        on the Site (collectively, the "Content") and the trademarks, service
        marks, and logos contained therein (the "Marks") are owned or controlled
        by us or licensed to us, and are protected by copyright and trademark
        laws.
      </p>

      <h3 data-id="element-241">4. User Representations</h3>
      <p data-id="element-242">
        By using the Site, you represent and warrant that: (1) you have the
        legal capacity and you agree to comply with these Terms of Service; (2)
        you are not a minor in the jurisdiction in which you reside; (3) you
        will not access the Site through automated or non-human means, whether
        through a bot, script or otherwise; (4) you will not use the Site for
        any illegal or unauthorized purpose; and (5) your use of the Site will
        not violate any applicable law or regulation.
      </p>

      <h3 data-id="element-243">5. Purchases and Payment</h3>
      <p data-id="element-244">
        We accept various forms of payment. You agree to provide current,
        complete, and accurate purchase and account information for all
        purchases made via the Site. You further agree to promptly update
        account and payment information, including email address, payment
        method, and payment card expiration date, so that we can complete your
        transactions and contact you as needed.
      </p>

      <h3 data-id="element-245">6. Refund Policy</h3>
      <p data-id="element-246">
        We offer a 100% money-back guarantee. If you are not satisfied with your
        purchase, please contact us within 30 days of your purchase for a full
        refund.
      </p>

      <h3 data-id="element-247">7. Limitation of Liability</h3>
      <p data-id="element-248">
        In no event will we or our directors, employees, or agents be liable to
        you or any third party for any direct, indirect, consequential,
        exemplary, incidental, special, or punitive damages, including lost
        profit, lost revenue, loss of data, or other damages arising from your
        use of the site, even if we have been advised of the possibility of such
        damages.
      </p>
    </div>;
}